// Mobile-viewport детектор.
//
// Виджет встраивается на ЛЮБОЙ host-сайт. Без правильной <meta name="viewport">
// iOS Safari эмулирует layout-viewport ~980 px → CSS @media (max-width: 480px)
// внутри shadow DOM не срабатывает, и window.innerWidth тоже становится 980.
//
// Стратегия: mobile = (узкое физическое разрешение) И (touch-устройство).
//
//   1. Touch — через matchMedia('(pointer: coarse)'). iPhone/iPad всегда
//      coarse, mouse-десктоп — fine. Это самый надёжный сигнал mobile-класса.
//   2. Ширина — Math.min(screen.width, innerWidth). screen.width отражает
//      физический CSS-px устройства независимо от layout-viewport
//      эмуляции. Порог 600 с запасом: iPhone Plus 430, складные ~540,
//      iPad 768 — не сработает (планшет ≠ телефон). На десктопе с
//      touchscreen ширина обычно ≥ 1366 → тоже false.
//
// Узкое окно на десктопе (drag-resize) без touch — false: ответственность
// за responsive верстку самого виджета на десктопе уже на CSS-positioning.

const MOBILE_THRESHOLD = 600;

export function isMobileViewport(win: Window = window): boolean {
  const isCoarse = win.matchMedia?.('(pointer: coarse)').matches ?? false;
  if (!isCoarse) return false;

  const screenW = win.screen?.width ?? Number.POSITIVE_INFINITY;
  const innerW = win.innerWidth ?? Number.POSITIVE_INFINITY;
  return Math.min(screenW, innerW) <= MOBILE_THRESHOLD;
}
